import { render, staticRenderFns } from "./ProdutosTable.vue?vue&type=template&id=fd394a28"
import script from "./ProdutosTable.vue?vue&type=script&lang=js"
export * from "./ProdutosTable.vue?vue&type=script&lang=js"
import style0 from "./ProdutosTable.vue?vue&type=style&index=0&id=fd394a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports